module.exports = __webpack_public_path__ + "img/toeic1.3b42a052.png";